import { dateService, FORMATS } from '@/global/services/date'

/**
 * The backend reports an irregularity nested - the type, the vehicle, the driver and
 * the task each as their own object, the coordinates and the address on
 * `geolocation` - while the details form shows one flat field per value. This is the
 * single place that translation lives, so the table and the details screen can never
 * read a report differently.
 *
 * Nothing here writes: reports arrive from the drivers' devices and the screens only
 * inspect them.
 */

/**
 * The report's timestamp as the screens show it. The backend sends it in
 * `Y-m-d H:i:s`, which is not what a user reads.
 */
export function toReportedAtLabel (record) {
  const reportedAt = record?.created_at

  return reportedAt
    ? dateService.formatCustom(reportedAt, FORMATS.isoDatetime, FORMATS.datetimeShort)
    : null
}

/**
 * Backend record -> the flat keys the fields and the map panel are bound to.
 */
export function toIrregularityForm (record) {
  const { type, vehicle, driver, task, geolocation } = record || {}

  return {
    irregularity_type: type?.description ?? null,
    vehicle: vehicle?.registration ?? null,
    driver: driver?.full_name ?? null,
    task: task?.name ?? null,
    address: geolocation?.address ?? null,
    latitude: geolocation?.latitude ?? null,
    longitude: geolocation?.longitude ?? null,
    reported_at: toReportedAtLabel(record)
  }
}

/**
 * Writes the flat keys onto the record itself. Content.vue hands `onDataReceived` the
 * very object it then turns into the form data, so the flat values have to land on it
 * rather than on a copy.
 */
export function applyIrregularityForm (record) {
  if (!record) {
    return record
  }

  return Object.assign(record, toIrregularityForm(record))
}
